var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('div',{staticClass:"row-1"},[_c('img',{staticClass:"logo",attrs:{"src":'static/img/logo_'+_vm.$i18n.locale+'.svg',"alt":"SAAMP Logo"}})]),_vm._v(" "),_c('div',{staticClass:"row-2"},[_c('h1',[_vm._v(_vm._s(_vm.$t('message.title')))])])]),_vm._v(" "),_c('main',[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08f5dcf3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 50
// module chunks = 1